import { FC } from 'react'
import * as S from './location.styles'
import CustomGoogleMap from '../GoogleMap/CustomGoogleMap'
import { useTranslation } from 'react-i18next'

const Location: FC = () => {
    const { t } = useTranslation()
    return (
        <>
            <S.Location>
                <div>
                    <div>
                        <S.LocationTitle>{t('home_location')}</S.LocationTitle>
                        <S.Address>
                            {t('contacts_address')}
                        </S.Address>
                    </div>
                    <S.LocationWorkTime>
                        <div>
                            <p>
                                <span>{t('contacts_mon_fri')}&nbsp;
                                    <time>10:00</time> - <time>20:00</time> </span>
                            </p>
                            <S.WeekendWorkTimes>
                                <span>{t('contacts_sat')}&nbsp;
                                    <time>10:00</time> - <time>18:00</time>, </span>
                                <span>{t('contacts_sun')}&nbsp;
                                    <time>10:00</time> - <time>16:00</time></span>
                            </S.WeekendWorkTimes>
                        </div>
                    </S.LocationWorkTime>
                </div>
                <CustomGoogleMap />
            </S.Location>
        </>
    )
}
export default Location